import goiDichVuLoaiXeMayCaNhan from '../assets/images/goidichvu_loaixemaycanhan.png'
import goiDichVuLoaiXeMayGiaDinh from '../assets/images/goidichvu_loaixemaygiadinh.png'
import goiDichVuLoaiXeOtoCaNhan from '../assets/images/goidichvu_loaixeotocanhan.png'
import headerBackground from '../assets/images/header_background.png'
import homeBannerDefault from '../assets/images/homebanner_default.png'
import paymentSuccess from '../assets/images/payment_success.png'
import quanLyDangKyBannerLanDau from '../assets/images/quanlydangki_bannerlandau.png'
import quanLyDangKyKhongCoXe from '../assets/images/quanlydangki_khongcoxe.png'
import quanLyDangKyLoiMang from '../assets/images/quanlydangki_loimang.png'
import resultHasViolation from '../assets/images/result_has_violation.png'
import resultNoViolation from '../assets/images/result_no_violation.png'
import thongTinGoiLoaiXeMayCaNhan from '../assets/images/thongtingoi_loaixemaycanhan.png'
import thongTinGoiLoaiXeMayGiaDinh from '../assets/images/thongtingoi_loaixemaygiadinh.png'
import thongTinGoiLoaiXeOtoCaNhan from '../assets/images/thongtingoi_loaixeotocanhan.png'
import traCuuBackgroundTop from '../assets/images/tracuu_background_top.png'
import trafficFineBenefits1 from '../assets/images/traffic_fine_benifits_1.png'
import trafficFineBenefits10 from '../assets/images/traffic_fine_benifits_10.png'
import trafficFineBenefits11 from '../assets/images/traffic_fine_benifits_11.png'
import trafficFineBenefits12 from '../assets/images/traffic_fine_benifits_12.png'
import trafficFineBenefits12V2 from '../assets/images/traffic_fine_benifits_12_v2.png'
import trafficFineBenefits13 from '../assets/images/traffic_fine_benifits_13.png'
import trafficFineBenefits13V2 from '../assets/images/traffic_fine_benifits_13_v2.png'
import trafficFineBenefits14 from '../assets/images/traffic_fine_benifits_14.png'
import trafficFineBenefits14V2 from '../assets/images/traffic_fine_benifits_14_v2.png'
import trafficFineBenefits2 from '../assets/images/traffic_fine_benifits_2.png'
import trafficFineBenefits3 from '../assets/images/traffic_fine_benifits_3.png'
import trafficFineBenefits4 from '../assets/images/traffic_fine_benifits_4.png'
import trafficFineBenefits5 from '../assets/images/traffic_fine_benifits_5.png'
import trafficFineBenefits6 from '../assets/images/traffic_fine_benifits_6.png'
import trafficFineBenefits7 from '../assets/images/traffic_fine_benifits_7.png'
import trafficFineBenefits8 from '../assets/images/traffic_fine_benifits_8.png'
import trafficFineBenefits9 from '../assets/images/traffic_fine_benifits_9.png'
import vnPay from '../assets/images/vnpay.png'

import iconArrowDown from '../assets/icons/arrow_down.svg'
import iconArrowRight from '../assets/icons/arrow_right.svg'
import iconBottomBarManage from '../assets/icons/bottom_bar_manage.svg'
import iconBottomBarSearch from '../assets/icons/bottom_bar_search.svg'
import iconCardLinkSupportPunish from '../assets/icons/card_link_support_punish.svg'
import iconCardLinkSupportQuestion from '../assets/icons/card_link_support_question.svg'
import iconCardLinkSupportService from '../assets/icons/card_link_support_service.svg'
import iconCheckCircleGreen from '../assets/icons/check_circle_green.svg'
import iconCheckCircleWhite from '../assets/icons/check_circle_white.svg'
import iconClock from '../assets/icons/clock.svg'
import iconClose from '../assets/icons/close.svg'
import iconExpiredWarning from '../assets/icons/expired-warning.svg'
import iconGoiDichVuGiaTien from '../assets/icons/goidichvu_giatien.svg'
import iconGoiDichVuSoLuongXe from '../assets/icons/goidichvu_soluongxe.svg'
import iconGoiDichVuSoLuongXeMay from '../assets/icons/goidichvu_soluongxemay.svg'
import iconGreenCheck from '../assets/icons/green_check.svg'
import iconBell from '../assets/icons/icon_bell.png'
import iconDanger from '../assets/icons/icon_danger.png'
import iconError from '../assets/icons/icon_error.png'
import iconPhoneCallStroke from '../assets/icons/phone_call_stroke.svg'
import iconPhoneCircleBrand from '../assets/icons/phone_circle_brand.svg'
import iconPlusCircleWhite from '../assets/icons/plus_circle_white.svg'

export const PRELOAD_IMAGE_ASSETS = [
  goiDichVuLoaiXeMayCaNhan,
  goiDichVuLoaiXeMayGiaDinh,
  goiDichVuLoaiXeOtoCaNhan,
  headerBackground,
  homeBannerDefault,
  paymentSuccess,
  quanLyDangKyBannerLanDau,
  quanLyDangKyKhongCoXe,
  quanLyDangKyLoiMang,
  resultHasViolation,
  resultNoViolation,
  thongTinGoiLoaiXeMayCaNhan,
  thongTinGoiLoaiXeMayGiaDinh,
  thongTinGoiLoaiXeOtoCaNhan,
  traCuuBackgroundTop,
  trafficFineBenefits1,
  trafficFineBenefits10,
  trafficFineBenefits11,
  trafficFineBenefits12,
  trafficFineBenefits12V2,
  trafficFineBenefits13,
  trafficFineBenefits13V2,
  trafficFineBenefits14,
  trafficFineBenefits14V2,
  trafficFineBenefits2,
  trafficFineBenefits3,
  trafficFineBenefits4,
  trafficFineBenefits5,
  trafficFineBenefits6,
  trafficFineBenefits7,
  trafficFineBenefits8,
  trafficFineBenefits9,
  vnPay,
  iconArrowDown,
  iconArrowRight,
  iconBottomBarManage,
  iconBottomBarSearch,
  iconCardLinkSupportPunish,
  iconCardLinkSupportQuestion,
  iconCardLinkSupportService,
  iconCheckCircleGreen,
  iconCheckCircleWhite,
  iconClock,
  iconClose,
  iconExpiredWarning,
  iconGoiDichVuGiaTien,
  iconGoiDichVuSoLuongXe,
  iconGoiDichVuSoLuongXeMay,
  iconGreenCheck,
  iconBell,
  iconDanger,
  iconError,
  iconPhoneCallStroke,
  iconPhoneCircleBrand,
  iconPlusCircleWhite
]
